import { curry, pipe } from 'rambda';
import constants from '../constants/actions';
import { setUserInfoData, userDuesDekorator } from '../services/decorator/menubar/userInfoData';
import setUserDataApi from '../services/decorator/user/setUserDataApi';
import { userInfoConnnector, userDuesConnector, userDataApiConnector } from '../services/connect/userInfoConnector';

const then = curry((f, p) => p.then(f)),

    getUserInfoData = () => {
        return async (dispatch) => {
            const response = await pipe(
                userInfoConnnector,
                then(setUserInfoData)
            )();
            dispatch({
                type: constants.USERINFO.USERINFO_FROM_JWT,
                payload: response
            });
        };
    };

const getUserDues = () => {
    return async (dispatch) => {
        dispatch({ type: constants.USERINFO.LOADER_REQUEST });
        const response = await pipe(userDuesConnector, then(userDuesDekorator))();
        dispatch({
            type: constants.USERINFO.USER_DUES,
            payload: response
        });
    };
};
const getUserDataApi = (payload) => {
    return async (dispatch) => {
        const response = await pipe(
            userDataApiConnector,
            then(setUserDataApi)
        )(payload);
        dispatch({
            type: constants.USERINFO.USERINFO_FROM_API,
            payload: response
        });
    };
};

export {
    getUserInfoData, getUserDues, getUserDataApi
};
